module.exports = __webpack_public_path__ + "img/pict-folder-share.fd5927bd.svg";